import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ReviewListLayer from "../../components/Review/ReviewListLayer";

const ReviewList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Review Management"  />

        <ReviewListLayer />
      </MasterLayout>
    </>
  );
};

export default ReviewList;
